import { http } from "./http.js";

async function getClientManager(id) {
  const response = await http.get(`clients/${id}`);
  return response.data.Manager ? {
    id: response.data.Manager.Id,
    title: response.data.Manager.Title,
  } : null;
}

async function assignClientManager(id, managerId) {
  const response = await http.patch(`clients/${id}/manager`, { value: managerId });
  return response;
}

export {
  getClientManager,
  assignClientManager,
};